<template>
  <div class="form-group type-select mb-3" v-show="shouldShow()">
    <label :for="item.label">
      <Lock v-if="item.response_private" />
      {{item.label | multitranslate}}
      <span v-if="item.required">*</span>
    </label>

    <p v-if="item.instructions">
      {{item.instructions | multitranslate}}
    </p>

    <v-select v-model="content" :options="options" :reduce="options => options.key" label="value" class="w-100" append-to-body>
      <template #search="{attributes, events}">
        <input class="vs__search form-control" :required="isRequired" v-bind="attributes" v-on="events" />
      </template>

      <template v-slot:option="option">
        {{ option.value | multitranslate }}
      </template>

      <template #selected-option-container="{ option, multiple }">
        <div class="vs__selected">
          {{ option.value | multitranslate }} 
          <span @click="deleteOpt(option)" class="pl-3" v-if="multiple">
            <i class="fas fa-times"></i>
          </span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<style scoped>
  label span {
    color: red;
  }

  .form-control {
    border:0;
  }
  .form-control :valid :invalid :focus, .is-invalid:focus, .is-valid:focus {
    box-shadow:unset;
    border:0;
  }

  .vs__dropdown-menu {
    height: 500px !important;
  }

  label {
    font-weight: bold;
    text-transform: uppercase;
    font-family: Montserrat, sans-serif, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color :#373e46;
  }
  .my-options {
    height:200px;
  }
</style>

<script>
import AbstractForm from './AbstractForm.vue';
export default {
  extends: AbstractForm,
  name: 'Select',  
  watch:{
    content:function(newValue){      
      if(newValue && newValue.toString().length > 0){
        this.isRequired = false
      } else {
        this.isRequired = this.item.required === 1
      }

      this.$nextTick(() => {
        this.setChanged();
      })
      
    }
  },
  data: function() {
    return {
      content: null,
      isRequired:false
    }
  },
  created() {
    this.isRequired = this.item.required === 1
    for(var i = 0; i < this.options.length; i++){
      var key;
      var value;

      if(this.options[i].hasOwnProperty('value')){
        value = this.options[i].key;
      } else {
        value = this.options[i];
      }

      if(this.options[i].hasOwnProperty('key')){
        key = this.options[i].key;
      } else {
        key = this.options[i];
      }

      this.options.splice(i, 1, {
        'key' : key, 
        'value' : value
      });

    }
  },
  methods: {    
  }
}
</script>
